export default __webpack_public_path__ + "static/media/ntbc.46e85fbb.svg";